const TrackingLink = 'https://bit.ly/2Oi0Nzx';

export default TrackingLink;
